export default __webpack_public_path__ + "752fa892ac1476442948cb4492b68f79.png";